import { render, staticRenderFns } from "./kushof.vue?vue&type=template&id=4e986f27&"
import script from "./kushof.vue?vue&type=script&lang=js&"
export * from "./kushof.vue?vue&type=script&lang=js&"
import style0 from "./kushof.vue?vue&type=style&index=0&id=4e986f27&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports